const api = "https://hungphatusa.buildzone.net/live/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const diamondSearchByReportApi = "devDiamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
// const productMetafield = "productMetafield";
const storeDefaultCurrencyCode = [ "EUR" ];

//var currencyCode = $("#currencyCode").val();
var currencyCode = "{{ cart.currency.iso_code }}";
var currencySymbol = getCurrenySymbol(currencyCode);

/*** Pre Declare Filter Arrays ***/
const cut_array = {"Poor": "Poor","Fair": "Fair", "Good": "Good", "Very Good": "Very Good", "Excellent": "Excellent"};
const cut_array_values = ["Poor", "Fair", "Good", "Very-Good", "Excellent"];

const polish_array = {"Poor": "Poor", "Fair": "Fair", "Good": "Good", "Very Good": "Very Good", "Excellent": "Excellent"};
const polish_array_values = ["Poor", "Fair", "Good", "Very Good", "Excellent"];

const symmetry_array = {"Poor": "Poor", "Fair": "Fair", "Good": "Good", "Very Good": "Very Good", "Excellent": "Excellent"};
const symmetry_array_values = ["Poor", "Fair", "Good", "Very Good", "Excellent"];

const fluorescence_array = {"Strong": "Strong", "Medium": "Medium", "Faint": "Faint", "None": "None"};
const fluorescence_array_values = ["Strong", "Medium", "Faint", "None"];

const clarity_array = {"I3": "I3", "I2": "I2", "I1": "I1", "SI3": "SI3", "SI2": "SI2","SI1": "SI1","VS2": "VS2","VS1": "VS1","VVS2": "VVS2","VVS1": "VVS1","IF": "IF","FL": "FL"};
const clarity_array_values = ["I3","I2","I1","SI3","SI2","SI1","VS2","VS1","VVS2","VVS1","IF","FL"];

const color_array = {"K": "K","J": "J","I": "I","H": "H","G": "G","F": "F","E": "E","D": "D"};
const color_array_values = ["K","J","I","H","G","F","E","D"];

const intensity_array = {"Faint":"Faint","Very Light":"Very Light","Light":"Light","Fancy Light":"Fancy Light","Fancy":"Fancy","Fancy Dark":"Fancy Dark","Intense":"Intense","Vivid":"Vivid","Deep":"Deep"};
const intensity_array_values = ["Faint","Very Light","Light","Fancy Light","Fancy","Fancy Dark","Intense","Vivid","Deep"];
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

// jQuery.ajax({
//     url:"https://04cd1c5ba7015aca0360f1deb387e01c:24c1c2df66cded0e483a1340a8b6c453@admin.shopify.com/store/330744/api/2023-10/users/current.json",
//    	type: 'get',
//     async: 'false',
//     dataType: 'json',
//     success: function(response) {
//       console.log(response);
//     }
// });

// jQuery.ajax({
//     url:"https://04cd1c5ba7015aca0360f1deb387e01c:24c1c2df66cded0e483a1340a8b6c453@admin.shopify.com/store/330744/api/2024-07/users/current.json",
//     type: 'get',
//     async: 'false',
//     dataType: 'json',
//     success: function(response) {
//       console.log(response);
//     }
// });


/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
        case 'EUR':
			currency_symbol = '€';
			break;
		case 'USD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '£';
			break;
		default:
			currency_symbol = '€';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {     
		$('.selected_filter_container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.selected_filter_container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.selected_filter_container').find('li[data-input="table"]').remove();
    }else if (input_value == 'cut') {
		$('.selected_filter_container').find('li[data-input="cut"]').remove();
	}else if (input_value == 'polish') {
		$('.selected_filter_container').find('li[data-input="polish"]').remove();
	}else if (input_value == 'symmetry') {
		$('.selected_filter_container').find('li[data-input="symmetry"]').remove();
	}else if (input_value == 'fluorescence') {
		$('.selected_filter_container').find('li[data-input="fluorescence"]').remove();
	}else if (input_value == 'clarity') {
		$('.selected_filter_container').find('li[data-input="clarity"]').remove();
	}else if (input_value == 'color') {
		$('.selected_filter_container').find('li[data-input="color"]').remove();
	}else if (input_value == 'intensity') {
		$('.selected_filter_container').find('li[data-input="intensity"]').remove();
	}
  
	var value = filter_value.split(':');
   
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
		if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '_container"><span class="tps_applied_filter_lable">' + value[0] + ':</span></ul>';
			$('.selected_filter_container').append(elecontainer);
			$('#' + value[0] + '_container').append(html);
		}      
	} else {
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/

if(store_lang == 'de'){
  var tps_config = {
	"urls": {
        "lab_color_diamond": "/pages/laborfarbiger-diamant",
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/naturlicher-weisser-diamant",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
	}
  }
}else{
  var tps_config = {
	"urls": {
        "lab_color_diamond": "/pages/natural-fancy-diamond",
        "lab_diamond": "/pages/natural-fancy-diamond",
        "loose_color_diamond": "/pages/natural-colored-diamond",        
        "loose_diamond": "/pages/natural-white-diamond",
        "loose_diamond_detail": "/pages/diamond-details",
	}

  }
}



/*** tps confif function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());

var carat = [];
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 1.5; i = i + 0.30) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.60) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < maxDiamondCarat; i = i + 0.65) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
carat.push(maxDiamondCarat);

Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = currencySymbol;

function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


if(store_lang == 'de'){
  var caratFilterUnit = 'Karat';
}else{
  var caratFilterUnit = 'Carat';
}  
function carat_slider_render(start, end, option) { 
    jQuery('.tps-diamondlist-result-list-view-loader').show();
    jQuery('.tps-diamondlist-result-grid-view-loader').show();
  
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
      
	var settingSelected = jQuery("#setting").val();

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);  
  
    var isSelected = false;      
 
    //session carat filter selected     
     if(parseFloat(start).toFixed(2) != min_carat || parseFloat(end).toFixed(2) != max_carat){
       isSelected = true;
     }    
    var caratFilterUnitchange = "ct.";
    var caratTitle = caratFilterUnit+': '+start + ' '+caratFilterUnitchange+' - '+end + ' '+caratFilterUnitchange;
       
     setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
     //end
  
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
        step: 1,
		slide: function(event, ui) {    
            emptyResultDiv();          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])]+' '+caratFilterUnitchange);
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])]+' '+caratFilterUnitchange);
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);          
		},
		change: function(event, ui) {   
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {                  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');   
                 
                //applied filter code start here                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != min_carat || carat[parseInt(ui.values[1])] != max_carat){
                       isSelected = true;
                 }                
                
                 setTimeout(function(){                  
                  var caratLeft = $('#carat_left_hidden').val();
                  var caratRight = $('#carat_right_hidden').val();
                             
                  var caratTitle = caratFilterUnit+': '+caratLeft+ ' '+caratFilterUnitchange+' - '+caratRight+ ' '+caratFilterUnitchange;
                   
                  setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
                  //end 
                  // var reportFlag = jQuery('#tps_search_by_stock').val();                
                    // if(reportFlag == ''){
                      graphqlDataCall();
                    // }  
                 }, 20);    			               
			}
           
		}

	});
    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start+' '+caratFilterUnitchange);
    $("#carat_to").val(end+' '+caratFilterUnitchange);
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);    
}


function replace_carat_from() {    
	var min_carat_value = minDiamondCarat;
	var settingSelected = jQuery("#setting").val();
    var caratFilterUnitchange = "ct.";
	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2)+' '+caratFilterUnitchange);
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
 
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		 if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#carat_from').val(value + ' Karat');
	} else if (value > value1) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else{
         alert('Incorrect carat range!');
        }
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' '+caratFilterUnitchange);
		return false;
	} else if (carat_value < min_carat_value) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else{
         alert('Incorrect carat range!');
        }
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2))+" "+caratFilterUnitchange);
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
      if(store_lang == 'de'){
        alert('Die gewählte Fassung passt zu einem Diamanten größer als ' + carat_value);
      }else{
        alert('selected setting can match with diamond greater than ' + carat_value);
      }		
		jQuery('#carat_from').val(hidden_carat_value+" "+caratFilterUnitchange);
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);
    
	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
     var caratFilterUnitchange = "ct.";
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2)+' '+caratFilterUnitchange);
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}   

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);        
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#carat_to').val(value + ' '+caratFilterUnitchange);
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {		
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else{
          alert("Incorrect carat range!");
        }
		jQuery('#carat_to').val(hidden_carat_value+" "+caratFilterUnitchange);
		return false;
	} else if (value1 > value) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else{
          alert("Incorrect carat range!");
        }
		$('#carat_to').val(hidden_carat_value+' '+caratFilterUnitchange);
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
        if(store_lang == 'de'){
          alert('Die gewählte Fassung passt zu einem Diamanten mit weniger als ' + carat_value);
        }else{
          alert('Selected setting can match with diamond less than ' + carat_value);
        }
		
		jQuery('#carat_to').val(hidden_carat_value+" "+caratFilterUnitchange);
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();

for (var i = 200; i < 1200; i = i+50) {
  price.push(i);
};
for (var i = 1200; i < 12000; i = i+100) {
  price.push(i);
};
for (var i = 12000; i < 24000; i = i+500) {
  price.push(i);
};
for (var i = 24000; i < 40000; i = i+1000) {
  price.push(i);
};
for (var i = 40000; i < 100000; i = i+5000) {
  price.push(i);
};
for (var i = 100000; i < 1000000; i = i+50000) {
  price.push(i);
};
for (var i = 1000000; i < 5000000; i = i+1000000) {
  price.push(i);
};
price.push(parseInt(maxDiamondPrice));

function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}


var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

function price_slider_render(start,end,option){
    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2);   

    if(store_lang == 'de'){
      var priceHeadTitle = 'Preis:';
    }else{
      var priceHeadTitle = 'Price:';
    }

    //session price filter selected
    var isSelected = false;
    if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
    }

    var priceTitle = priceHeadTitle+' '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);    
    
    setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
     //end
    
        jQuery("#price-slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ start1,end1 ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
               jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
               jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
  
               var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
               jQuery('#price_from').val(price_form);
               var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
               jQuery('#price_to').val(price_to);
                          
            },
            change: function(event, ui) {
              if(option == true) {                 
                 emptyResultDiv();                 
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                  
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
                       isSelected = true;
                 }           
                
                 var priceTitle = priceHeadTitle+' '+price_form+' - '+price_to;          
                 
                 setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
                 //end                               
                 
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');
                  graphqlDataCall();
	 			}else if(option == false){
                   jQuery('#price_left_hidden').val(start);
                   jQuery('#price_right_hidden').val(end);
      
                   var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   jQuery('#page_no').val(1);
                   jQuery('#pagination').val('');
                
                   graphqlDataCall();
                   setTimeout(function(){ 
                     option = true;
                     return false;
                   }, 20);
                }
              slide = '';
            }
             
        });
  		  
          var start_num = parseInt(start);
          var end_num = parseInt(end);
	
          var start_dec= start_num.toFixed(0);
          var end_dec= end_num.toFixed(0);
  
         jQuery('#price_left_hidden').val(start_dec);
         jQuery('#price_right_hidden').val(end_dec);  		 
         jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
  		 jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {

	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else {
		var value = jQuery('#price_to').val();
        value = value.replace('$', '');
      value = value.replace(/\.0+$/, "");
	}

	var value1 = jQuery('#price_left_hidden').val();
	if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
  	  value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }
  
	value = parseInt(value);
	value1 = parseInt(value1);
   
	if (isNaN(value) != false) {
		var value = maxDiamondPrice;
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#1000000').val(value + currency_symbol);
	} else if (value > maxDiamondPrice) {   
        if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else{
          alert('Incorrect price range!');
        }
		
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else if (value1 > value) {      
		if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else{
          alert('Incorrect price range!');
        }
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
  
	price_slider_render(value1, value, false);

}

function replace_price_from() {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
		return false;
	} else {
		var value = jQuery('#price_from').val();
        value = value.replace('$', '');
      value = value.replace(/\.0+$/, "");
	}
	var value1 = jQuery('#price_right_hidden').val();
     
    if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
      value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }
  
	value = parseInt(value);
	value1 = parseInt(value1); 

	if (isNaN(value) != false) {      
		var value = minDiamondPrice;
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else{
          alert('Please enter value in number');
        }
      
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
	} else if (value < minDiamondPrice) {      
		 if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else{
          alert('Incorrect price range!');
        }
		var valLimit = parseFloat(jQuery('#price_left_hidden').val());        
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
		return false;
	} else if (value > value1) {      
		 if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else{
          alert('Incorrect price range!');
        }
		price_slider_render(price[0], value1, false);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, false);

}
/*** Diamond Price Filter End ***/

/*** Diamond Depth Filter Start ***/
var depth = [];

for (i = 46; i < 78; i = i + 0.10) {
	var dec = i.toFixed(1);
	depth.push(dec);
}

var min_depth_filter = 46.0;
var max_depth_filter = 78.0;

function depth_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);

     //session depth filter selected
     var isSelected = false;      
     if(parseInt(start) != parseInt(min_depth_filter) || parseInt(end) != parseInt(max_depth_filter)){
       isSelected = true;
     }

     var depthTitle = 'Depth: '+start+' - '+end;
     setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
     //end
  
	jQuery("#depth-slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#depth_from").val(depth[parseInt(ui.values[0])]);
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])]);
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#depth_from").val(depth[parseInt(ui.values[0])]);
    			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
    			$('#depth_to').val(depth[parseInt(ui.values[1])]);
    			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);

                 //applied filter start
                 var isSelected = false;               
                 if(depth[parseInt(ui.values[0])] != parseInt(min_depth_filter) || depth[parseInt(ui.values[1])] != parseInt(max_depth_filter)){
                       isSelected = true;
                 }
                var depthTitle = 'Depth: '+depth[parseInt(ui.values[0])] +' - '+depth[parseInt(ui.values[1])];
                setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
    			
            }
                //end
            
              // var reportFlag = jQuery('#tps_search_by_stock').val();                
              // if(reportFlag == ''){
                graphqlDataCall();
              // }
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#depth_from").val(Start_limit.toFixed(1));
	$("#depth_to").val(End_limit.toFixed(1));
	$('#depth_left_hidden').val(start);
	$('#depth_right_hidden').val(end);
}

function replace_depth_from() {

	var min_depth_value = 46.0;

	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val(value.toFixed(1));
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var value = depth_value;
	
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
	
	if (isNaN(value) != false) {
		var value = 46.0;
		alert("Please enter value in number");
		jQuery('#depth_from').val(value);
	} else if (value > value1) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val(value.toFixed(1));
		return false;
	} else if (depth_value < min_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_from').val(min_depth_value);
		depth_slider_render(min_depth_value, value1, true);
		return false;
	}

	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);

	depth_slider_render(value, value1, true);
}

function replace_depth_to() {

	var max_depth_value = 78;

	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val(value.toFixed(1));
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}	
	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());

	if (isNaN(value) != false) {
		var value = 78.0;
		alert('Please enter value in number');
		jQuery('#depth_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val(value.toFixed(1));
		return false;
	} else if (value > max_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_to').val(max_depth_value);
		depth_slider_render(value1, max_depth_value, true);
		return false;
	}

	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Table Filter Start ***/
var table = [];

for (i = 50; i < 80; i = i + 0.10) {
	var dec = i.toFixed(1);
	table.push(dec);
}

var min_table_filter = 50.0;
var max_table_filter = 80.0;

function table_slider_render(start, end, option) {
	var start2 = getClosestNum(start, table);
	var end2 = getClosestNum(end, table);
	var start1 = get_index(start2, table);
	var start11 = get_index(start, table);
	var end11 = get_index(end, table);
	var end1 = get_index(end2, table);

    //session depth filter selected
     var isSelected = false;
     if(start != parseInt(min_table_filter) || end != parseInt(max_table_filter)){
       isSelected = true;
     }

     var tableTitle = 'Table: '+start+' - '+end;
     setSelectedFilter(tableTitle,"table_slider_render('"+parseInt(min_table_filter)+"', '"+parseInt(max_table_filter)+"','true')",isSelected,'table');
     //end
  
	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])]);
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])]);
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {
				if (option == true) {
					jQuery('#page_no').val(1);
					jQuery('#pagination').val('');					

                    $("#table_from").val(table[parseInt(ui.values[0])]);
        			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
        			$('#table_to').val(table[parseInt(ui.values[1])]);
        			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
                 
                    //applied filter start
                     var isSelected = false;
                     if(table[parseInt(ui.values[0])] != min_table_filter || table[parseInt(ui.values[1])] != max_table_filter){
                           isSelected = true;
                     }
                    var tableTitle = 'Table: '+table[parseInt(ui.values[0])] +' - '+table[parseInt(ui.values[1])];
                    setSelectedFilter(tableTitle,"table_slider_render('"+min_table_filter+"', '"+max_table_filter+"','true')",isSelected,'table');

                    // var reportFlag = jQuery('#tps_search_by_stock').val();                
                    // if(reportFlag == ''){
                      graphqlDataCall();
                    // }
				}


			}
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#table_from").val(Start_limit.toFixed(1));
	$("#table_to").val(End_limit.toFixed(1));

	$('#table_left_hidden').val(start);
	$('#table_right_hidden').val(end);
}

function replace_table_from() {

	var min_table_value = 50;

	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val(value.toFixed(1));
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());
	
	if (isNaN(value) != false) {
		var value = 50.0;
		alert('Please enter value in number');
		jQuery('#table_from').val(value);
	} else if (value > value1) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val(value.toFixed(1));
		return false;
	} else if (table_value < min_table_value) {
		alert('Incorrect table range!');
		$('#table_from').val(min_table_value);
		table_slider_render(min_table_value, value1, true);
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(value, value1, true);
}

function replace_table_to() {

	var max_table_value = 80;

	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(1)));
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());
	
	if (isNaN(value) != false) {
		var value = 80.0;
		alert('Please enter value in number');
		jQuery('#table_to').val(value);
	} else if (value1 > value) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val(value.toFixed(1));
		return false;
	} else if (value > max_table_value) {
		$('#table_to').val(max_table_value);
		table_slider_render(value1, max_table_value, true);
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, value, true);
}
/*** Diamond Table Filter End ***/

/************************** Start - Diamond Cut Filter **************************/
var min_cut = jQuery( "#cut-min-value" ).val();
var max_cut = jQuery( "#cut-max-value" ).val();
function cut_slider_render(start,end,option){
  
  if(store_lang == 'de'){
    var cutHeadTitle = 'Schliffgrad:';
  }else{
    var cutHeadTitle = 'Cut:';
  }

  //session cut filter selected
  var isSelected = false;
  if(start != 0 || end != 5){
     isSelected = true;
  }
  
  var selected_values = getFilterValues(min_cut,max_cut,'cut');
  
  if(selected_values[0] == selected_values[1]){
    var cutTitle = cutHeadTitle+' '+selected_values[1];
  }else{
    var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
      
  
  setSelectedFilter(cutTitle,"cut_slider_render('0', '5','false')",isSelected,'cut');
  //end
  
  jQuery( "#cut_range" ).slider({ 
      range: true,
      values: [start, end],
       min: 0,
       max: 5,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery( "#cut-min-value" ).val(ui.values[0]);
          jQuery( "#cut-max-value" ).val(ui.values[1]);
           
      },
      change: function( event, ui ) {  
         emptyResultDiv();
        
         jQuery( "#cut-min-value" ).val(ui.values[0]);
         jQuery( "#cut-max-value" ).val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != 5){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'cut');
          
          if(selected_values[0] == selected_values[1]){
            var cutTitle = cutHeadTitle+' '+selected_values[1];    
          }else{
            var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
          }
          
          
          setSelectedFilter(cutTitle,"cut_slider_render('0', '5','false')",isSelected,'cut');
         //end
        
        jQuery('#page_no').val(1);
	    jQuery('#pagination').val('');
        graphqlDataCall();
        return false;
      }
   });
}
/************************** End - Diamond Cut Filter **************************/
/************************** Start - Diamond Polish Filter **************************/
	var min_polish = jQuery( "#polish-min-value" ).val();
	var max_polish = jQuery( "#polish-max-value" ).val();

	function polish_slider_render(start,end,option){

		if(store_lang == 'de'){
			var polishHeadTitle = 'Politur:';
		}else{
			var polishHeadTitle = 'Polish:';
		}

		//session Polish filter selected
		var isSelected = false;
		if(start != 0 || end != 5){
		   isSelected = true;
		}

		var selected_values = getFilterValues(min_polish,max_polish,'polish');

		if(selected_values[0] == selected_values[1]){
			var polishTitle = polishHeadTitle+' '+selected_values[1];
		}else{
		    var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
		}

		setSelectedFilter(polishTitle,"polish_slider_render('0', '5','false')",isSelected,'polish');
  		//end

  		jQuery( "#polish_range" ).slider({ 
	      range: true,
	      values: [start, end],
	       min: 0,
	       max: 5,
	       step: 1, 
	       slide: function( event, ui ) {          
	          if ((ui.values[0]) >= (ui.values[1])) {
	            return false;
	          }
	             
	          jQuery( "#polish-min-value" ).val(ui.values[0]);
	          jQuery( "#polish-max-value" ).val(ui.values[1]);
	           
	      },
	      change: function( event, ui ) {  
	         emptyResultDiv();
            
	         jQuery( "#polish-min-value" ).val(ui.values[0]);
	         jQuery( "#polish-max-value" ).val(ui.values[1]);
	        
	         //applied filters 
	         var isSelected = false;         
	         if(ui.values[0] != 0 || ui.values[1] != 5){
	               isSelected = true;
	         }          
	         var selected_values = getFilterValues(ui.values[0],ui.values[1],'polish');
	          
	          if(selected_values[0] == selected_values[1]){
	            var polishTitle = polishHeadTitle+' '+selected_values[1];    
	          }else{
	            var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
	          }
	          
	          
	          setSelectedFilter(polishTitle,"polish_slider_render('0', '5','false')",isSelected,'polish');
	         //end
	        
	        jQuery('#page_no').val(1);
		    jQuery('#pagination').val('');
	        graphqlDataCall();
	        return false;
	      }
	   });
	}
/************************** End - Diamond Polish Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
  var min_symmetry = jQuery( "#symmetry-min-value" ).val();
  var max_symmetry = jQuery( "#symmetry-max-value" ).val();

  function symmetry_slider_render(start,end,option){

    if(store_lang == 'de'){
      var symmetryHeadTitle = 'Symmetrie:';
    }else{
      var symmetryHeadTitle = 'Symmetry:';
    }

    //session Symmetry filter selected
    var isSelected = false;
    if(start != 0 || end != 5){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_symmetry,max_symmetry,'symmetry');

    if(selected_values[0] == selected_values[1]){
      var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];
    }else{
        var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '5','false')",isSelected,'symmetry');
      //end

      jQuery( "#symmetry_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 5,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#symmetry-min-value" ).val(ui.values[0]);
            jQuery( "#symmetry-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#symmetry-min-value" ).val(ui.values[0]);
           jQuery( "#symmetry-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 5){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'symmetry');
            
            if(selected_values[0] == selected_values[1]){
              var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];    
            }else{
              var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
            setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '5','false')",isSelected,'symmetry');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Symmetry Filter **************************/
/************************** Start - Diamond fluorescence Filter **************************/
  var min_fluorescence = jQuery( "#fluorescence-min-value" ).val();
  var max_fluorescence = jQuery( "#fluorescence-max-value" ).val();

  function fluorescence_slider_render(start,end,option){
  
    if(store_lang == 'de'){
      var fluorescenceHeadTitle = 'Fluoreszenz:';
    }else{
      var fluorescenceHeadTitle = 'Fluorescence:';
    }

    //session fluorescence filter selected
    var isSelected = false;
    if(start != 0 || end != 4){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_fluorescence,max_fluorescence,'fluorescence');

    if(selected_values[0] == selected_values[1]){
      var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];
    }else{
        var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', '4','false')",isSelected,'fluorescence');
      //end

      jQuery( "#fluorescence_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 4,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
            jQuery( "#fluorescence-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
           jQuery( "#fluorescence-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 4){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'fluorescence');
            
            if(selected_values[0] == selected_values[1]){
              var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];    
            }else{
              var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', '4','false')",isSelected,'fluorescence');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond fluorescence Filter **************************/
/************************** Start - Diamond clarity Filter **************************/
  var min_clarity = jQuery( "#clarity-min-value" ).val();
  var max_clarity = jQuery( "#clarity-max-value" ).val();

  function clarity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var clarityHeadTitle = 'Reinheit:';
    }else{
      var clarityHeadTitle = 'Clarity:';
    }

    //session clarity filter selected
    var isSelected = false;
    if(start != 0 || end != 12){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');

    if(selected_values[0] == selected_values[1]){
      var clarityTitle = clarityHeadTitle+' '+selected_values[1];
    }else{
        var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(clarityTitle,"clarity_slider_render('0', '12','false')",isSelected,'clarity');
      //end

      jQuery( "#clarity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 12,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#clarity-min-value" ).val(ui.values[0]);
            jQuery( "#clarity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#clarity-min-value" ).val(ui.values[0]);
           jQuery( "#clarity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 12){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');
            
            if(selected_values[0] == selected_values[1]){
              var clarityTitle = clarityHeadTitle+' '+selected_values[1];    
            }else{
              var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(clarityTitle,"clarity_slider_render('0', '12','false')",isSelected,'clarity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond clarity Filter **************************/
/************************** Start - Diamond Color Filter **************************/
  var min_color = jQuery( "#color-min-value" ).val();
  var max_color = jQuery( "#color-max-value" ).val();

  function color_slider_render(start,end,option){

    if(store_lang == 'de'){
      var colorHeadTitle = 'Farbe:';
    }else{
      var colorHeadTitle = 'Color:';
    }

    //session color filter selected
    var isSelected = false;
    if(start != 0 || end != 8){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_color,max_color,'color');

    if(selected_values[0] == selected_values[1]){
      var colorTitle = colorHeadTitle+' '+selected_values[1];
    }else{
        var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(colorTitle,"color_slider_render('0', '8','false')",isSelected,'color');
      //end

      jQuery( "#color_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 8,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#color-min-value" ).val(ui.values[0]);
            jQuery( "#color-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#color-min-value" ).val(ui.values[0]);
           jQuery( "#color-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 8){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'color');
            
            if(selected_values[0] == selected_values[1]){
              var colorTitle = colorHeadTitle+' '+selected_values[1];    
            }else{
              var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(colorTitle,"color_slider_render('0', '8','false')",isSelected,'color');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Color Filter **************************/
/************************** Start - Diamond Intensity Filter **************************/
  var min_intensity = jQuery( "#intensity-min-value" ).val();
  var max_intensity = jQuery( "#intensity-max-value" ).val();

  function intensity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var intensityHeadTitle = 'Intensität:';
    }else{
      var intensityHeadTitle = 'Intensity:';
    }

    //session intensity filter selected
    var isSelected = false;
    if(start != 0 || end != 9){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_intensity,max_intensity,'intensity');

    if(selected_values[0] == selected_values[1]){
      var intensityTitle = intensityHeadTitle+' '+selected_values[1];
    }else{
        var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(intensityTitle,"intensity_slider_render('0', '9','false')",isSelected,'intensity');
      //end

      jQuery( "#intensity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 9,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#intensity-min-value" ).val(ui.values[0]);
            jQuery( "#intensity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#intensity-min-value" ).val(ui.values[0]);
           jQuery( "#intensity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 9){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'intensity');
            
            if(selected_values[0] == selected_values[1]){
              var intensityTitle = intensityHeadTitle+' '+selected_values[1];    
            }else{
              var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(intensityTitle,"intensity_slider_render('0', '9','false')",isSelected,'intensity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Intensity Filter **************************/

/***Diamond sorting Filter Start ***/
function sorting_data(sorting, className) {
     emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value');
    jQuery('.sortvaluename').text(sort_text);      

  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);



	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond sorting Filter End ***/

function getFilterValues(min_value,max_value,filter) {
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array;  
  }else if(filter == 'polish'){
    filterArray = polish_array;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){     
    if(store_lang == 'de'){
       if(i == min_value){
        selected_values.push(cut);
      }
      if(i == max_value-1){
        selected_values.push(cut);
      }
    }else{
      if(i == min_value){
        selected_values.push(key);
      }
      if(i == max_value-1){
        selected_values.push(key);
      }
    }
    i++;     
  });
  
  return selected_values;
}

function getFilterUrlValues(filterValues,filter){
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array_values;  
  }else if(filter == 'polish'){
    filterArray = polish_array_values;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array_values;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array_values;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array_values;  
  }else if(filter == 'color'){
    filterArray = color_array_values;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array_values;  
  }
  
  var urlFilterValues = filterValues.split(','); 

  var selected_values = [];  
  var selected_values_keys = [];

  if(filter != 'carat'){
    $.each(urlFilterValues, function(arrkey,url_cut){
      $.each(filterArray, function(key,cut){
        if(url_cut == cut){
          selected_values.push(key);
        }        
      });
    });                  
      
    if(selected_values.length != 0){
      var min_value = Math.min.apply(Math,selected_values); 
      var max_value = Math.max.apply(Math,selected_values); 
      max_value = max_value+1; 
      
      selected_values_keys.push(min_value);
      selected_values_keys.push(max_value);
    }  
  }else{
    if(urlFilterValues.length == 1){
      var min_value = urlFilterValues[0]; 
      var max_value = urlFilterValues[0]; 
    }else{
      var min_value = urlFilterValues[0]; 
      var max_value = urlFilterValues[1]; 
    }

    selected_values_keys.push(min_value);
    selected_values_keys.push(max_value);
  }
    
  return selected_values_keys;  
}

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/

/*** Product Detail Description Tabs ***/
$(document).on("click", ".tps_product_title", function(e) {
  e.stopPropagation();
  var data_section = jQuery(this).attr("data-section");  
  
  if(jQuery(this).hasClass("active")){
    jQuery(".tps_product_tabs").removeClass("active");
    jQuery(".tps_product_detail_secions").hide(); 

    jQuery(".tps_product_title").removeClass("active"); 
  }else{
      jQuery(".tps_product_tabs").removeClass("active");
      jQuery(".tps_"+data_section).addClass("active");

      jQuery(".tps_product_title").removeClass("active"); 
      jQuery(this).addClass("active");
    
      jQuery(".tps_product_detail_secions").hide(); 
      jQuery(".tps_product_"+data_section).slideDown("slow"); 
  }
  
});